
export abstract class BaseRepository {
  abstract list(): Promise<any[]>;
  token?: string;

  setToken(_token?: string) {
    this.token = _token;
  }
}
